"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.elProps = exports.HTMLMarginSpan = void 0;
exports.wrapHTMLComponent = wrapHTMLComponent;
const react_1 = __importDefault(require("react"));
// eslint-disable-next-line no-irregular-whitespace
const HTMLMarginSpan = props => react_1.default.createElement("span", { ...props }, "\u3000");
exports.HTMLMarginSpan = HTMLMarginSpan;
function wrapHTMLComponent(htmlComponentID, Component) {
    const ret = ((props) => {
        const { htmlOptions } = props;
        if (htmlOptions.WrapComponent) {
            return (react_1.default.createElement(htmlOptions.WrapComponent, { htmlComponentID: htmlComponentID, childProps: props, ChildComponent: Component }));
        }
        else {
            return react_1.default.createElement(Component, { ...props });
        }
    });
    ret.componentID = htmlComponentID;
    return ret;
}
const elProps = (el, htmlOptions) => {
    const ret = {};
    if (htmlOptions.annotateLawtextRange && el.range) {
        ret["data-lawtext_range"] = JSON.stringify(el.range);
        ret["data-el_id"] = JSON.stringify(el.id);
    }
    return ret;
};
exports.elProps = elProps;
//# sourceMappingURL=html.js.map